import {
  ADD_CART_ITEM,
  UPDATE_CART,
  REMOVE_CART_ITEM,
  SUBSCRIPTION_DETAILS_BY_ID,
  REQUEST,
  FAIL,
  SET_ORDER_DETAILS,
  SET_MULTIPLE_CARDS,
  SET_CREDIT_CARD,
  SET_SOURCE_ID,
  IS_FETCHING,
  CHECKOUT_PAYMENT_ERROR,
  SET_PROGRAM_PRODUCTS,
} from 'constants/cartConstants';

export const cartItemsReducer = (state, action) => {
  switch (action.type) {
    case REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAIL:
      return {
        loading: false,
        error: true,
      };
    case ADD_CART_ITEM:
      return {
        ...state,
        cartItems: [
          ...state.cartItems.filter(
            item =>
              item.sku !== action.payload.sku &&
              item.type !== action.payload.type
          ),
          action.payload,
        ],
        lastItem: action.payload,
        alreadyExist:
          // state.cartItems.filter(
          //   item =>
          //     item.sku == action.payload.sku && item.type == action.payload.type
          // ).length > 0
          //   ? true
          //   : false,
          false,
      };

    case UPDATE_CART:
      return {
        ...state,
        cartItems: state.cartItems.map(item => {
          return item.sku === action.payload.sku
            ? { ...item, ...action.payload }
            : item;
        }),
      };
    case REMOVE_CART_ITEM:
      return {
        ...state,
        cartItems: state.cartItems.filter(item => item.sku !== action.payload),
        alreadyExist:
          // state.cartItems.filter(item => item.sku == action.payload)
          // ? false
          // : state.alreadyExist,
          false,
      };
    case SUBSCRIPTION_DETAILS_BY_ID:
      return {
        ...state,
        loading: false,
        subscriptionDetails: state.subscriptions.filter(
          subscription => subscription._id === Number(action.payload)
        )[0],
      };
    case SET_ORDER_DETAILS:
      return {
        ...state,
        order: action.payload,
      };
    case SET_PROGRAM_PRODUCTS:
      return {
        ...state,
        programProducts: action.payload,
      };
    case SET_MULTIPLE_CARDS:
      return {
        ...state,
        multipleCards: [...state.multipleCards, action.payload],
      };
    case SET_CREDIT_CARD:
      return {
        ...state,
        cc: action.payload,
      };
    case SET_SOURCE_ID:
      return {
        ...state,
        paymentSourceId: action.payload,
      };
    case IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case CHECKOUT_PAYMENT_ERROR:
      return {
        ...state,
        showPaymentError: action.payload !== null,
        paymentErrorMsg: action.payload,
      };
    default:
      return state;
  }
};
